/* sb-dc-tplcut.js — 디자인센터가 «손님이 고른 그 1장» 만 받게 한다.
   그리고 왼쪽 레일의 Templates 패널을 내린다. (2026-09-05)

   왜 이 파일이 생겼나
   ────────────────────
   손님 동선은 이렇게 정해졌다:
     상품 페이지 → 디자인 템플릿 페이지 → 디자인 클릭 → 편집기에 그 디자인이 떠 있다.
   템플릿 페이지에서 이미 골랐으므로 편집기 안에 또 고르는 자리는 필요 없다.

   그런데 그 «고르는 자리»(Templates 패널) 때문에 편집기가 들어올 때마다
   카탈로그를 통째로 받고 있었다. sb-dc-aug.js:3161 fetchRemote() 가

     dc_templates?active=eq.true&select=*&order=sort.asc,created_at.desc

   로 433행을 받고, 그 433장의 SVG 원본을 «전부» 내려받고(6.21MB),
   «전부 도착해야» 목록을 세우고(:3179 map(remoteToTpl)), 그 remoteToTpl 은
   한 장마다 svgToLayers(:2814) 로 SVG 를 진짜 DOM 에 심어 요소마다
   getBBox()·getComputedStyle() 로 크기를 잰다. 3,900여 개를 한 덩어리로.

   실측 (라이브, 2026-09-04):
     빠른 회선                디자인 뜨기까지  7.1초 · 버려진 템플릿   0장
     3G·약한 와이파이 1.6Mbps                19.8초 ·               18장
     약한 LTE 0.8Mbps                        26.8초 ·              156장
     CPU 4배 느린 노트북      한 덩어리 정지 5,646ms

   오른쪽 칸이 두 번째 이유다. finish() 는 12초 안에 본문이 안 온 SVG 행을
   목록에서 «버린다». 즉 지금 패널은 느린 손님에게 433장 중 3분의 1을
   아예 안 보여주고 있었다. 패널을 내리면 이 두 가지가 같이 사라진다.

   하는 일 네 가지
   ────────────────
   1. 그 한 요청의 주소에 &id=eq.<tpl> 을 붙인다. 서버가 걸러 주므로 이쪽에서
      응답을 뜯어고칠 일이 없다. ?tpl= 이 없으면 &limit=0 — 패널이 없으니
      목록 자체가 필요 없다.
   2. 레일의 Templates 버튼을 숨긴다.
   3. 없어진 메뉴를 가리키던 빈 상태 문구를 바꾼다.
   4. 앱바의 «Design Center» 링크(sb-dc-home.js 가 이미 걸어 둔 것)를
      눈에 띄게 한다 — 다른 디자인으로 바꾸러 갈 유일한 길이므로.

   ⚠ __dcTemplateList 를 «비우는» 방식으로 패널을 없애면 안 된다.
      sb-dc-tplfix.js:363 이 그 목록에서 손님이 고른 디자인을 찾아 그린다.
      목록은 살리고 버튼만 숨기는 것이 이 파일의 방식이다.

   ⚠ 반드시 sb-dc-aug.js «앞» 에서 실행돼야 한다. 그 번들이 요청을 보내기
      전에 window.fetch 가 감싸져 있어야 하기 때문이다. layout/design-center.liquid
      의 sb-dc-handle.js 다음 줄이 그 자리다. */
(function () {
  'use strict';

  if (window.__dcTplCut) return;
  window.__dcTplCut = { cut: 0, mode: '', hidBtn: false, netShown: false };

  var m = /[?&]tpl=([^&]+)/.exec(location.search);
  var ID = m ? decodeURIComponent(m[1]) : '';
  var UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  /* ── 1. 목록 요청을 잘라낸다 ─────────────────────────────────────────── */

  /* aug 번들의 «목록» 요청만 고른다. 다른 세 곳은 select= 가 달라서 안 걸린다:
       sb-dc-tplprod.js  select=id,products
       sb-dc-tplfix.js   select=fit,width_px,height_px
       sb-dc-tpl.js      select=name,file_url,…                        */
  function isListCall(u) {
    return u.indexOf('/rest/v1/dc_templates') > -1 && u.indexOf('select=*') > -1;
  }

  /* 붙일 조건. ?tpl= 이 UUID 가 아니면 손대지 않는다 — 이상한 값을 그대로
     보내면 PostgREST 가 400 을 주고, 번들이 그것을 «템플릿을 못 불러왔다» 는
     경고띠로 띄운다. 그 경우는 예전 그대로 두는 편이 안전하다. */
  function suffix() {
    if (ID) return UUID.test(ID) ? '&id=eq.' + encodeURIComponent(ID) : '';
    return '&limit=0';
  }

  /* 앞선 감싸개(varfix·sizeguard·genfetch·cartprops)가 주소를 Request 로 바꿔
     넘길 수 있으므로 두 모양을 다 받는다.
     ⚠ 'use strict' 에서는 arguments 가 매개변수와 연결되지 않는다. 바꾼 주소를
        realFetch.apply(this, arguments) 로 넘기면 원래 주소가 그대로 나간다
        (실제로 그렇게 새어 433장을 다 받았다). 반드시 call 로 넘긴다. */
  var realFetch = window.fetch;
  if (typeof realFetch === 'function') {
    window.fetch = function (input, init) {
      try {
        var isReq = typeof Request === 'function' && input instanceof Request;
        var url = typeof input === 'string' ? input : (isReq ? input.url : '');
        if (url && isListCall(url)) {
          var add = suffix();
          if (add) {
            input = isReq ? new Request(url + add, input) : url + add;
            window.__dcTplCut.cut++;
            window.__dcTplCut.mode = ID ? 'one:' + ID : 'none';
          }
        }
      } catch (e) { /* 자르기가 실패해도 요청 자체는 나가야 한다 */ }
      return realFetch.call(this, input, init);
    };
  }

  /* ── 2·3·4. 화면 ─────────────────────────────────────────────────────── */

  /* 스타일은 <head> 맨 뒤에 붙으므로 sb-dc-arial.css 보다 뒤다 — 같은 순위끼리는
     뒤에 온 쪽이 이긴다. */
  function addStyle() {
   try {
    if (document.getElementById('sb-dc-tplcut-css')) return;
    var st = document.createElement('style');
    st.id = 'sb-dc-tplcut-css';
    st.textContent =
      /* 3. 빈 상태 문구. .fp-empty 는 두 군데 쓰인다 — «No text yet.»(글자 패널)
            과 «Still empty. Templates is the fastest place to start.»(레이어 패널).
            <b> 를 가진 쪽이 후자이므로 :has(b) 로 그것만 고른다. :has() 를 모르는
            옛 브라우저는 예전 문구가 남는데, 없어진 메뉴를 가리키는 낡은 안내일
            뿐 고장은 아니다. */
      '.fp-empty:has(b){font-size:0!important}' +
      '.fp-empty:has(b)::after{content:"Nothing on the board yet. Pick a finished design '
        + 'from the Design Templates page — the link is at the top left.";'
        + 'font-size:12px;line-height:1.55;display:block}' +
      /* 4. 앱바의 «Design Center» — sb-dc-home.js 가 이미 role=link 와 클릭을
            걸어 두었다. 새로 만들 것은 없고 링크처럼 보이게만 한다. 패널이
            없어진 뒤 다른 디자인으로 바꾸러 갈 유일한 길이다. */
      '.appbar .brand-name i{color:var(--accent,#00697f)!important;'
        + 'text-decoration:underline;text-underline-offset:2px}' +
      '.appbar .brand-name i:hover{color:var(--accent-2,#00596c)!important}' +
      /* 안전망 띠 안의 링크 */
      '.sbdc-announce a{color:#fff;text-underline-offset:2px}';
    (document.head || document.documentElement).appendChild(st);
   } catch (e) {}
  }
  /* head 가 아직 없는 시점에 실행될 수 있다(문서보다 먼저 도는 경우). 그때
     그냥 appendChild 하면 조용히 실패하고 아래 세 가지 손질이 통째로 사라진다.
     — 실제로 검사 도구에서 그렇게 새는 것을 잡았다. */
  if (document.head) addStyle();
  else document.addEventListener('DOMContentLoaded', addStyle);

  /* 2. 레일의 Templates 버튼.
     번들이 그리는 버튼에 id 가 없고 글자로만 구분되므로 CSS 로는 못 짚는다.
     class 대신 «인라인 style» 로 숨긴다 — React 는 이 자리에 style 을 쓰지
     않으므로 다시 그려도 지워지지 않는다 (class 는 is-active 가 바뀔 때
     통째로 덮어써진다). */
  function hideTemplatesBtn() {
    var btns = document.querySelectorAll('.rail-btn');
    for (var i = 0; i < btns.length; i++) {
      var lab = btns[i].querySelector('.rail-label');
      if (lab && (lab.textContent || '').trim() === 'Templates') {
        btns[i].style.setProperty('display', 'none', 'important');
        return true;
      }
    }
    return false;
  }
  var tries = 0;
  var timer = setInterval(function () {
    if (hideTemplatesBtn()) { window.__dcTplCut.hidBtn = true; clearInterval(timer); }
    else if (++tries > 150) clearInterval(timer);        // 30초 뒤 포기
  }, 200);
  window.addEventListener('pagehide', function () { clearInterval(timer); });

  /* ── 안전망 ──────────────────────────────────────────────────────────────
     ?tpl= 으로 들어왔는데 디자인이 끝내 안 뜨는 경우.

     거의 일어나지 않는다: 템플릿 페이지의 카드 썸네일이 쓰는 주소가 편집기가
     받는 주소와 같고(sections/sb-dc-templates.liquid:382 return t.file_url),
     저장소가 cache-control: public, max-age=3600 을 주므로, 손님이 그 카드를
     눌렀다는 것은 그 파일을 이미 받아 봤다는 뜻이다. 회선을 0.8~1.6Mbps 로
     낮추고 앞쪽·뒤쪽 디자인으로 5번 시험해 5번 다 정상으로 떴다.

     그래도 넣는 이유: 캐시가 1시간 뒤 만료된 상태로 눌렀다거나 그 행이
     비활성이면 빈 판이 되는데, 패널이 없어진 지금은 손님이 나가는 것 말고
     할 수 있는 일이 없다. 띠는 sb-dc-aug.js 가 쓰는 것과 같은 것을 쓴다. */
  function root() {
    try {
      var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      if (r) return r;
    } catch (e) {}
    return 'https://stickersbanners.com/';
  }
  if (ID) {
    setTimeout(function () {
      try {
        var a = window.__dcApi;
        if (!a) return;                                   // 편집기 자체가 안 떴다 — 다른 문제
        if ((a.doc && a.doc.layers && a.doc.layers.length) || 0) return;
        /* 번들도 같은 자리(position:fixed, top:58px)에 «Uploaded templates 1
           could not be loaded» 띠를 띄운다. 패널이 없어진 지금 손님에게
           «목록» 이야기는 뜻이 없고, 두 장이 겹쳐 읽히지도 않는다.
           그 경고띠(.is-warn)만 걷어내고 이쪽 한 장으로 말한다 — 관리자 공지
           띠는 is-warn 이 아니므로 건드리지 않는다. */
        var old = document.querySelectorAll('.sbdc-announce.is-warn');
        for (var i = 0; i < old.length; i++) old[i].remove();

        /* 2026-09-05 — 이 띠에서 is-warn 을 뺐다. 자홍색(--mag)은 «주문이
           막혔다» 는 색인데, 여기서 일어난 일은 고른 디자인 하나가 안 열린
           것뿐이고 손님은 바로 옆 링크로 다른 것을 고르면 된다. 기본
           .sbdc-announce 는 검은 띠라 관리자 공지와 같은 «안내» 로 읽힌다.
           위의 걷어내기 선택자는 그대로 .is-warn 이다 — 그건 번들이 띄우는
           띠를 지우는 것이고, 우리 띠는 이제 거기 걸리지 않아 스스로를 지울
           걱정도 없다. */
        var bar = document.createElement('div');
        bar.className = 'sbdc-announce';
        var sp = document.createElement('span');
        sp.textContent = 'We could not load that design. ';
        var go = document.createElement('a');
        go.href = root() + 'pages/design-templates';
        go.textContent = 'Choose another →';
        sp.appendChild(go);
        var x = document.createElement('button');
        x.type = 'button';
        x.innerHTML = '&times;';
        x.onclick = function () { bar.remove(); };
        bar.appendChild(sp);
        bar.appendChild(x);
        document.body.appendChild(bar);
        window.__dcTplCut.netShown = true;
      } catch (e) {}
    }, 60000);   // 2026-09-16: aug now waits up to 50s for a heavy template; this «could not load» bar must come after that
  }
})();
